export default __webpack_public_path__ + "static/img5-c9e2a9a0aa313d56d91c38c05dc85ff7.png";